// extracted by mini-css-extract-plugin
var _1 = "FloatingToolbar-module__animatedBackground--bvWFb";
var _2 = "FloatingToolbar-module__container--hu0d6";
var _3 = "FloatingToolbar-module__hoverWrapper--DWFLi";
var _4 = "FloatingToolbar-module__leftAligned--_NL2S";
var _5 = "20px";
export { _1 as "animatedBackground", _2 as "container", _3 as "hoverWrapper", _4 as "leftAligned", _5 as "nearSideHoverTolerance" }
